<template>
  <div class="card-container">
    <common-el-form
      :model="formModel"
      :rules="formRules"
      :submitData="submitData"
      @success="onSuccess"
      @cancel="onCancel"
      submit-btn-text="提交"
      failTitle="提交失败"
      loadingText="提交中..."
      :submitService="submitService"
      labelWidth="110px"
    >
      <el-form-item label="机构序号" prop="orderNumber">
        <el-input
          v-model="formModel.orderNumber"
          placeholder="请输入机构序号"
          maxlength="3"
          show-word-limit
          style="width: 300px"
        ></el-input>
        <!--<el-input-number :step="1" :min="0" :controls="false" v-model="formModel.orderNumber" style="width: 300px" step-strictly></el-input-number>-->
      </el-form-item>
      <el-form-item label="机构名称" prop="tatName">
        <el-input
          v-model="formModel.tatName"
          placeholder="请输入机构名称"
          maxlength="20"
          show-word-limit
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="应用名称" prop="appName">
        <el-input
          v-model="formModel.appName"
          placeholder="请输入应用名称"
          maxlength="20"
          show-word-limit
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="机构简称" prop="tatSimpleName">
        <el-input
          v-model="formModel.tatSimpleName"
          placeholder="请输入应用名称"
          maxlength="20"
          show-word-limit
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="connPerson">
        <el-input
          v-model="formModel.connPerson"
          placeholder="请输入联系人"
          maxlength="20"
          show-word-limit
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="connTel">
        <el-input
          type="textarea"
          placeholder="多个电话请以 '，' 分割"
          v-model="formModel.connTel"
          maxlength="100"
          show-word-limit
          resize="none"
          rows="4"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱" prop="email">
        <el-input
          v-model="formModel.email"
          placeholder="请输入联系邮箱"
          maxlength="50"
          show-word-limit
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系地址" prop="address">
        <el-input
          type="textarea"
          v-model="formModel.address"
          resize="none"
          maxlength="200"
          show-word-limit
          placeholder="请输入联系地址"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="客服电话" prop="customerPhone">
        <el-input
          type="textarea"
          v-model="formModel.customerPhone"
          resize="none"
          maxlength="200"
          show-word-limit
          placeholder="请输入客服电话"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="客服微信" prop="wechat">
        <el-input
          type="textarea"
          v-model="formModel.wechat"
          resize="none"
          maxlength="200"
          show-word-limit
          placeholder="请输入客服微信"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="客服公众号" prop="publicWechat">
        <el-input
          type="textarea"
          v-model="formModel.publicWechat"
          resize="none"
          maxlength="200"
          show-word-limit
          placeholder="请输入客服公众号"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户私钥" prop="priKey" v-if="organID">
        <el-input
          type="textarea"
          v-model="formModel.priKey"
          resize="none"
          style="width: 300px"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="所属区域" prop="regionCode">
        <choose-address
          @regionCode="getRegionCode"
          :regionCode="regionCode"
        ></choose-address>
      </el-form-item>
      <el-form-item label="机构缩写" prop="tatAbbr">
        <el-input
          v-model="formModel.tatAbbr"
          placeholder="请输入机构缩写"
          maxlength="20"
          show-word-limit
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="合同起始日期" prop="time">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="合同开始日期"
          end-placeholder="合同结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="注册开关" prop="registerSwitch">
        <el-switch
          v-model="formModel.registerSwitch"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="1"
          inactive-value="0"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="登录开关" prop="loginSwitch">
        <el-switch
          v-model="formModel.loginSwitch"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="1"
          inactive-value="0"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="登录提示语" prop="loginInfo">
        <el-input
          type="textarea"
          rows="5"
          v-model="formModel.loginInfo"
          resize="none"
          maxlength="100"
          show-word-limit
          placeholder="请输入提示语"
          style="width: 300px"
        ></el-input>
      </el-form-item>
    </common-el-form>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import ChooseAddress from "components/business/ChooseAddress";
import Regs from "common/conf/Regs";
import OrganService from "service/OrganService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, validatorsMixin } from "mixin";
import StorageService from "store/interfaces";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AddOrganManage",
  data() {
    return {
      formRules: {
        tatName: [
          {
            required: true,
            // message: '请输入机构名称'
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入机构名称"));
              } else if (this.checkTatNameOnly) {
                callback(new Error("机构名称不能重复"));
              } else {
                callback();
              }
            },
          },
        ],
        appName: [
          {
            required: true,
            // message: '请输入应用名称'
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入应用名称"));
              } else if (this.checkAppNameOnly) {
                callback(new Error("应用名称不能重复"));
              } else {
                callback();
              }
            },
          },
        ],
        tatSimpleName: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入机构简称"));
              } else if (this.checkSimpleNamesOnly) {
                callback(new Error("机构简称不能重复"));
              } else {
                callback();
              }
            },
          },
        ],
        connPerson: [
          {
            required: true,
            message: "请输入联系人",
          },
        ],
        connTel: [
          {
            required: true,
            // validator: this.validPhone,
            // validator: (rule, value, callback) => {
            //     if (!value) {
            //        return callback(new Error('请输入联系电话'))
            //     }
            //     const telArr = value.split(',');
            //     console.log('telArr', telArr);
            //     telArr.forEach(item => {
            //         if (!Regs.phone.test(item)) {
            //            return callback(new Error('请输入正确的11位手机号码并以‘，’分割'))
            //         }
            //     })
            //     return callback();
            // },
            message: "请输入联系电话",
            trigger: ["blur", "change"],
          },
        ],
        email: [
          {
            required: false,
            validator: this.validEmail,
            trigger: ["blur", "change"],
          },
        ],
        tatAbbr: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入机构缩写"));
              } else if (this.checkAbbrsOnly) {
                callback(new Error("机构缩写不能重复"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      formModel: {
        orderNumber: "",
        tatName: "",
        appName: "",
        tatSimpleName: "",
        connPerson: "",
        connTel: "",
        email: "",
        address: "",
        priKey: "",
        tatAbbr: "",
        province: "",
        customerPhone: "",
        publicWechat: "",
        wechat: "",
        city: "",
        area: "",
        validStart: "合同开始日期",
        validEnd: "合同结束日期",
        loginSwitch: "1",
        registerSwitch: "1",
        loginInfo: "",
      },
      tatSimpleNames: [],
      getTatSimpleName: "",
      getTatAbbr: "",
      getTatName: "",
      getAppName: "",
      abbrs: [],
      organID: "",
      time: [],
      regionCode: "",
      tatName: [],
      appName: [],
    };
  },
  mixins: [loadMixin, validatorsMixin],
  components: {
    CommonElForm,
    ChooseAddress,
  },
  mounted() {
    this.organID = this.$route.params.id;
    if (this.organID) {
      this.getInfo();
    }
    this.getSimpleNames();
    this.getAbbrs();
    this.getCheckList();
  },
  computed: {
    checkTatNameOnly() {
      for (let i = 0; i < this.tatName.length; i++) {
        if (this.formModel.tatName == this.tatName[i]) {
          if (this.getTatName == this.tatName[i]) {
            return false;
          }
          return true;
        } else {
          if (i == this.tatName.length - 1) {
            return false;
          }
        }
      }
    },
    checkAppNameOnly() {
      for (let i = 0; i < this.appName.length; i++) {
        if (this.formModel.appName == this.appName[i]) {
          if (this.getAppName == this.appName[i]) {
            return false;
          }
          return true;
        } else {
          if (i == this.appName.length - 1) {
            return false;
          }
        }
      }
    },
    checkSimpleNamesOnly() {
      for (let i = 0; i < this.tatSimpleNames.length; i++) {
        if (this.formModel.tatSimpleName == this.tatSimpleNames[i].simpleName) {
          if (this.getTatSimpleName == this.tatSimpleNames[i].simpleName) {
            return false;
          }
          return true;
        } else {
          if (i == this.tatSimpleNames.length - 1) {
            return false;
          }
        }
      }
    },
    checkAbbrsOnly() {
      for (let i = 0; i < this.abbrs.length; i++) {
        if (this.formModel.tatAbbr == this.abbrs[i].tatAbbr) {
          if (this.getTatAbbr == this.abbrs[i].tatAbbr) {
            return false;
          }
          return true;
        } else {
          if (i == this.abbrs.length - 1) {
            return false;
          }
        }
      }
    },
    submitService() {
      if (this.organID) {
        return OrganService.update;
      } else {
        return OrganService.add;
      }
    },
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }

      this.params = {
        orderNumber: this.formModel.orderNumber,
        tatName: this.formModel.tatName,
        appName: this.formModel.appName,
        tatSimpleName: this.formModel.tatSimpleName,
        connPerson: this.formModel.connPerson,
        connTel: this.formModel.connTel,
        email: this.formModel.email,
        address: this.formModel.address,
        customerPhone: this.formModel.customerPhone,
        publicWechat: this.formModel.publicWechat,
        wechat: this.formModel.wechat,
        regionCode: this.regionCode,
        province: this.formModel.province,
        city: this.formModel.city,
        area: this.formModel.area,
        tatAbbr: this.formModel.tatAbbr,
        validStart: this.time[0],
        validEnd: this.time[1],
        userId: this.userId,
        loginInfo: this.formModel.loginInfo,
        loginSwitch: this.formModel.loginSwitch,
        registerSwitch: this.formModel.registerSwitch,
      };
      if (this.time.length == 0) {
        this.params.validStart = "";
        this.params.validEnd = "";
      }
      if (this.organID) {
        this.params.id = this.organID;
      }

      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    "formModel.enablePublicPlatoon"(val, oldVal) {
      if (val == 0) {
        this.formModel.enablePublicPlatoonSenior = 0;
      }
    },
  },
  methods: {
    getRegionCode(regionCode, province, city, area) {
      this.regionCode = regionCode;
      this.formModel.province = province;
      this.formModel.city = city;
      this.formModel.area = area;
    },
    getCheckList() {
      this.doLoad(
        OrganService.getTatAndApps,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            for (let i = 0; i < result.length; i++) {
              this.tatName.push(result[i].tatName);
              this.appName.push(result[i].appName);
            }
          });
        },
        "信息获取失败"
      );
    },
    getInfo() {
      const params = {
        id: this.organID,
        userId: this.userId,
      };

      this.doLoad(
        OrganService.detail,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            let result = res.contents;
            this.formModel = result;

            this.regionCode = this.formModel.regionCode;
            this.orderNumber = this.formModel.orderNumber
              ? this.formModel.orderNumber
              : "";

            this.getTatSimpleName = this.formModel.tatSimpleName;
            this.getTatAbbr = this.formModel.tatAbbr;
            this.getTatName = this.formModel.tatName;
            this.getAppName = this.formModel.appName;
            if (this.formModel.validStart == null) {
              this.time = [];
            } else {
              this.time.push(
                this.formModel.validStart,
                this.formModel.validEnd
              );
            }
            if (this.formModel.email == null) {
              this.formModel.email = "";
            }
            if (this.formModel.address == null) {
              this.formModel.address = "";
            }
          });
        },
        "信息获取失败"
      );
    },
    getSimpleNames() {
      this.doLoad(
        OrganService.simpleNames,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.tatSimpleNames = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    getAbbrs() {
      this.doLoad(
        OrganService.abbrs,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.abbrs = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      if (res.respCode == "0000") {
        this.showSuccess(res.respMsg);
        this.reloadTat(true);
        this.isReloadPage(true);
        this.$router.replace({
          name: "organmanage",
        });
      } else {
        this.showError(res.respMsg);
      }
    },
    onCancel() {
      this.$router.back();
    },
    ...mapActions({
      reloadTat: StorageService.Reload.tatNameList,
      isReloadPage: StorageService.Reload.page,
    }),
  },
};
</script>

<style scoped>
.el-form-item {
  display: flex;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/AddOrganManage.vue